import React from 'react';
import Fade from 'react-reveal/Fade';

const AboutMe = () => {
    return (
        <div className="container mt-5" id="#about">
            <div className="row mt-5">
                <div className="col-md-6 mt-3">
                    <h3 className=""><span style={{ borderBottom: '3px solid green' }}>ABOUT ME</span></h3>
                    <Fade left>
                        <h5 className="mt-5" style={{ color: '#008000' }}>Raj Dev Ullash</h5>
                        <p>I'm a Passionate <span style={{ color: '#008000' }}>Front End Developer</span></p>
                        <h6 className="mt-3" style={{ lineHeight: "30px", textAlign: 'justify' }}>My name is Raj Dev Ullash I'm a Front End Developer from Bangladesh. I describe myself as a passionate developer who loves coding, open source, and the web platform ❤.

                        Aside from my project, I like to create and contribute to open source projects. That helps me to learn a ton of new stuff, grow as a developer and support other open source projects. Also I enjoy writing technical things at my blog.

                    In my free time you can find me longboarding , at the gym, at the beach or on tech meetups and conference.</h6>
                    </Fade>
                </div>
                <div className="col-md-6  mt-5 ">
                    <div className="mt-5">
                        <Fade right>
                            <div className="d-flex ms-md-5 ps-md-5">
                                <div>
                                    <i className="fas fa-map-marker-alt fa-1x" style={{ color: '#198754' }}></i>
                                </div>
                                <div className="ms-5">
                                    <h5>Chattogram, Bangladesh</h5>
                                </div>
                            </div>
                            <div className="d-flex mt-2 ms-md-5 ps-md-5">
                                <div>
                                    <i className="far fa-envelope-open fa-1x" style={{ color: '#198754' }}></i>
                                </div>
                                <div className="ms-5">
                                    <h5>rajdevullash111@gmail.com</h5>
                                </div>
                            </div>
                            <div className="d-flex mt-2 ms-md-5 ps-md-5">
                                <div>
                                    <i className="fas fa-mobile-alt fa-1x" style={{ color: '#198754' }} ></i>
                                </div>
                                <div className="ms-5">
                                    <h5>+88 01644836367</h5>
                                </div>
                            </div>
                        </Fade>
                    </div>
                    <div className="ms-md-5 ps-md-5 mt-5">
                        <Fade bottom>
                            <a className="" href="https://www.facebook.com/princeboy.rd.9"><i className="fab fa-facebook fa-2x m-2 ms-md-auto card-demos" style={{ color: '#198754' }}></i></a>
                            <a href="https://www.linkedin.com/in/raj-dev-ullash-831512203/"><i className="fab fa-linkedin fa-2x m-2 card-demos" style={{ color: '#198754' }}></i></a>
                            <a href="https://github.com/Rajdev-ullash"><i className="fab fa-github fa-2x m-2 card-demos" style={{ color: '#198754' }}></i></a>
                        </Fade>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;